import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../components/header';
import { publishActions } from '../actions/publishActions';

export class BulkPublish extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFile: null
        }
        this.bulkPublish = this.bulkPublish.bind(this);
        this.onChangeHandler = this.onChangeHandler.bind(this);
    }
    onChangeHandler(event) {
        this.setState({
            selectedFile: event.target.files[0]
        })
    }
    bulkPublish() {
        const data = new FormData()
        data.append('file', this.state.selectedFile);
        this.props.bulkPublish(data);
    }
    render() {
        return (
            <div className="wrapper">
                <div className="content-wrapper">
                    <section className="content">
                        <Header></Header>
                        <div className="row margin-t-150">
                            <div className="col-md-4"></div>
                            <div className="col-md-4">
                                <input type='file' className="btn btn-default" onChange={this.onChangeHandler} />

                                {this.props.fetching ? <div className="row"><div className="col-md-5"></div>  <div className="loader col-md-2"></div></div>
                                    :
                                    <button type="submit" className="btn btn-primary margin" onClick={this.bulkPublish}>Publish</button>}
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { fetching } = state.notification;
    return {
        fetching
    };
};

const actionCreators = {
    bulkPublish: publishActions.bulkPublish
}

export default connect(mapStateToProps, actionCreators)(BulkPublish);
